//TODO: REPLACE TEMPORARY VALUES WITH REAL ONES
export const LOCKED_POSITION_AMMs: Record<string, string> = {
    "1": "https://www.curve.finance/dex/ethereum/pools/factory-stable-ng-469/deposit/",
    "2": "https://www.curve.finance/dex/ethereum/pools/factory-stable-ng-470/deposit/",
    "4": "https://www.curve.finance/dex/ethereum/pools/factory-stable-ng-471/deposit/",
    "6": "https://www.curve.finance/dex/ethereum/pools/factory-stable-ng-472/deposit/",
    "8": " https://www.curve.finance/dex/ethereum/pools/factory-stable-ng-473/deposit/",
    "13": "https://www.curve.finance/dex/ethereum/pools/factory-stable-ng-474/deposit/",
};
